import { ConnectKitButton } from 'connectkit';
import { useAccount, useBalance } from 'wagmi';
import { formatEther } from 'ethers';

export function WalletConnection() {
  const { address } = useAccount();
  const { data: balance } = useBalance({ address });

  return (
    <ConnectKitButton.Custom>
      {({ isConnected, show, truncatedAddress, ensName, chain }) => {
        if (!isConnected) {
          return (
            <button
              onClick={show}
              className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white text-sm font-medium rounded-full shadow-md hover:shadow-lg transition-all duration-200 hover:-translate-y-0.5"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              <span>Connect</span>
            </button>
          );
        }

        if (chain?.unsupported) {
          return (
            <button
              onClick={show}
              className="flex items-center gap-2 px-4 py-2 bg-red-500 hover:bg-red-600 text-white text-sm font-medium rounded-full shadow-md transition-all duration-200"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
              <span>Wrong Network</span>
            </button>
          );
        }

        const displayBalance = balance
          ? `${Number(formatEther(balance.value)).toFixed(3)} ${balance.symbol}`
          : null;

        return (
          <button
            onClick={show}
            className="flex items-center gap-3 pl-3 pr-4 py-2 bg-white/80 hover:bg-white border border-slate-200 hover:border-slate-300 rounded-full shadow-sm hover:shadow-md transition-all duration-200 group"
          >
            {/* Avatar/Identicon */}
            <div className="w-7 h-7 rounded-full bg-gradient-to-br from-blue-400 via-purple-500 to-pink-500 flex items-center justify-center ring-2 ring-white">
              <span className="text-white text-xs font-bold">
                {(ensName || truncatedAddress || '').slice(0, 2).toUpperCase()}
              </span>
            </div>

            {/* Address & Balance */}
            <div className="flex flex-col items-start">
              <span className="text-sm font-medium text-slate-800 group-hover:text-slate-900">
                {ensName || truncatedAddress}
              </span>
              {displayBalance && (
                <span className="text-xs text-slate-500">
                  {displayBalance}
                </span>
              )}
            </div>

            {/* Dropdown indicator */}
            <svg className="w-4 h-4 text-slate-400 group-hover:text-slate-600 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        );
      }}
    </ConnectKitButton.Custom>
  );
}
